var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "js-clipper-fixed"
  }, [_c('div', {
    staticClass: "vuejs-clipper-fixed__wrap js-wrap",
    style: _vm.wrapStyle
  }, [_c('canvas', {
    staticClass: "vuejs-clipper-fixed__stem-outer",
    attrs: {
      "width": _vm.stemArea.width,
      "height": _vm.stemArea.height
    }
  }), _c('div', {
    staticClass: "vuejs-clipper-fixed__img-center"
  }, [_c('canvas', {
    staticClass: "vuejs-clipper-fixed__stem-bg js-stem-bg"
  }), _c('div', {
    staticClass: "vuejs-clipper-fixed__img-scale js-img-scale",
    style: _vm.scaleStyle
  }, [_c('div', {
    staticClass: "vuejs-clipper-fixed__img-translate js-img-translate",
    style: _vm.translateStyle
  }, [_c('img', {
    staticClass: "vuejs-clipper-fixed__img js-img",
    style: _vm.bgStyle,
    attrs: {
      "src": _vm.src,
      "crossorigin": _vm.crossOrigin
    },
    on: {
      "load": function load($event) {
        _vm.imgLoaded();

        _vm.emit('load', $event);
      },
      "error": function error($event) {
        return _vm.emit('error', $event);
      }
    }
  })])])]), _c('div', {
    staticClass: "vuejs-clipper-fixed__cover"
  }, [_c('div', {
    staticClass: "vuejs-clipper-fixed__area js-area",
    style: _vm.areaStyle
  }, [_c('canvas', {
    staticClass: "vuejs-clipper-fixed__stem-area",
    style: _vm.stemStyle,
    attrs: {
      "width": _vm.stemArea.width,
      "height": _vm.stemArea.height
    }
  }), _vm.grid ? _c('div', {
    staticClass: "vuejs-clipper-fixed__grid"
  }, _vm._l(4, function (index) {
    return _c('div', {
      key: 'gridItem' + index,
      staticClass: "vuejs-clipper-fixed__grid-item"
    });
  }), 0) : _vm._e()])])]), _c('div', {
    staticClass: "vuejs-clipper-fixed__placeholder",
    style: _vm.eptStyle
  }, [_vm._t("placeholder")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }